import {useCompanyTariffGuard} from '../../../../modules/company-tariff';
import {FC, useContext, useEffect, useState} from 'react';
import {useForm} from 'react-hook-form';
import {useSetRecoilState} from 'recoil';
import LoadingButton from '@mui/lab/LoadingButton/LoadingButton';
import {Box, Button, Divider, Modal, Stack, Toolbar, Typography} from '@mui/material';
import ControlledInput from '../../../../ui/controlled-input/ControlledInput';
import {DictionaryService} from '../../../../api/services/dictionary.service';
import {deviceTypesDictQueryTrigger} from '../../../../store/deviceTypes/atoms';
import {IDeviceTypesDictPostBody} from '../../../../shared/types/deviceTypesDict.types';
import {EventBusContext} from '../../../../providers/EventBus';
import {transliterateRuToUpperCase} from '../../../../shared/helpers/transliteration';

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  width: 500,
  p: 2,
};

interface IModalNewType {
  open: boolean;
  handleClose: () => void;
}

export const ModalNewType: FC<IModalNewType> = ({open, handleClose}) => {
  const {checkTariff, tariffLoading} = useCompanyTariffGuard();
  const {control, trigger, getValues, watch, setValue} = useForm<IDeviceTypesDictPostBody>();
  const triggerDeviceTypesQuery = useSetRecoilState(deviceTypesDictQueryTrigger);
  const [loading, setLoading] = useState(false);
  const {bus} = useContext(EventBusContext);

  const name = watch('name');

  const handleCreate = async () => {
    setLoading(true);

    const data = getValues();

    try {
      await DictionaryService.createDeviceType(data);

      triggerDeviceTypesQuery((v) => v + 1);
      setTimeout(() => {
        setLoading(false);
        handleClose();
      }, 0);
    } catch (err: any) {
      bus?.emit('error', [err]);

      setLoading(false);
    }
  };

  useEffect(() => {
    setValue('code', transliterateRuToUpperCase(name));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);

  return (
    <Modal open={open}>
      <Box sx={style}>
        <Toolbar
          sx={{
            pl: {sm: 1},
            pr: {xs: 1, sm: 1},
          }}
        >
          <Typography sx={{flex: '1 1 100%'}} variant="h6" id="formTitle" component="div">
            Новый тип
          </Typography>
        </Toolbar>
        <Divider sx={{m: '10px 0'}} />
        <Stack direction="column" spacing={3}>
          <Stack direction="row" spacing={3}>
            <ControlledInput
              control={control}
              name="name"
              size="small"
              label="Название"
              disabled={loading}
              rules={{
                required: 'Обязательно для заполнения',
              }}
            />
            <ControlledInput control={control} name="code" size="small" disabled label="Код типа" />
          </Stack>
          <ControlledInput
            control={control}
            name="description"
            rules={{
              maxLength: {
                value: 400,
                message: 'Максимум 400 символов',
              },
            }}
            disabled={loading}
            label="Комментарий"
            multiline
            rows={4}
            additionalFunc={() => {
              trigger('description');
            }}
          />
          <Stack direction="row" sx={{justifyContent: 'space-between'}}>
            <Button variant="outlined" color="error" disabled={loading} onClick={handleClose}>
              Отменить
            </Button>
            <LoadingButton
              color="primary"
              variant="contained"
              onClick={() => {
                if (!checkTariff()) return;
                void trigger().then((bool) => {
                  if (bool) void handleCreate();
                });
              }}
              disabled={tariffLoading}
              loading={loading}
            >
              Добавить
            </LoadingButton>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};
